module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_goteborg-a40b917c89bb9e327e3ab879d7e20f0d.png";